"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const predicates_1 = require("../predicates");
exports.record = (keyPredicate, valuePredicate) => (value) => {
    const isObjectValue = predicates_1.isObject(value);
    if (isObjectValue) {
        for (const key in value) {
            if (Object.hasOwnProperty.call(value, key) &&
                (!keyPredicate(key) || !valuePredicate(value[key]))) {
                return false;
            }
        }
    }
    return isObjectValue;
};
//# sourceMappingURL=record.js.map